import React from 'react';
import useAxios from 'axios-hooks';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

// Pages
import Start from './views/start';
import Cart from './views/cart';
import Header from './components/header';
import { stampedUrl } from './config';
import { StampedProvider } from './StampedContext';

const App = () => {
  const [data, setData] = React.useState();
  const [page, setPage] = React.useState(1);
  const [reviews, setReviews] = React.useState();
  const [pageAmount, setPageAmount] = React.useState();
  const [{ error, loading }, getReviews] = useAxios(stampedUrl(1), {
    manual: true,
  });

  // Calculate possible amount of pages
  const getPageAmount = (reviewData: any) => {
    const amountPerPage = reviewData?.data?.length;
    return Math.round(reviewData?.total / amountPerPage);
  };

  // Fetch stamped data on mount
  React.useEffect(() => {
    getReviews().then(({ data }) => {
      setData(data);
      setReviews(data.data);
      setPageAmount(getPageAmount(data));
    });
  }, [getReviews]);

  // On pagination: fetch next batch of reviews
  const loadMoreReviews = () => {
    getReviews({
      url: stampedUrl(page + 1),
    }).then(({ data }) => {
      setPage(data.page);
      setReviews([...reviews, ...data.data]);
    });
  };

  return (
    <BrowserRouter>
      <StampedProvider
        value={{
          data,
          reviews,
          currentPage: page,
          pageAmount,
          error,
          loading,
          loadMoreReviews: (newPage: number) => loadMoreReviews(),
        }}
      >
        <>
          <Header />
          <Switch>
            <Route path="/" component={Start} exact />
            <Route path="/cart" component={Cart} exact />
          </Switch>
        </>
      </StampedProvider>
    </BrowserRouter>
  );
};

export default App;
